var Y = Object.defineProperty;
var x = (r, n, i) => n in r ? Y(r, n, { enumerable: !0, configurable: !0, writable: !0, value: i }) : r[n] = i;
var m = (r, n, i) => (x(r, typeof n != "symbol" ? n + "" : n, i), i);
import { defineComponent as N, openBlock as t, createElementBlock as o, createElementVNode as f, toDisplayString as g, ref as M, computed as k, watch as E, resolveComponent as ee, renderSlot as w, normalizeClass as W, createVNode as $, unref as K, withCtx as A, Fragment as I, renderList as T, createCommentVNode as L, createBlock as b, withDirectives as O, withModifiers as ie, vShow as D, createSlots as z } from "vue";
import "@patsnap-ui/icon/assets/solid/ArrowsmallDown.svg";
import "@patsnap-ui/icon/assets/solid/ArrowSmallUp.svg";
import { ElTooltip as R } from "element-plus";
import "element-plus/es/components/tooltip/style/css";
import U from "@patsnap-biz/icon";
const ne = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, te = {
  key: 0,
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10.2679 6.16667C10.2679 5.52267 10.5964 5 11.0012 5L21.2667 5C21.6715 5 22 5.52267 22 6.16667C22 6.81067 21.6715 7.33333 21.2667 7.33333L11.0012 7.33334C10.5964 7.33334 10.2679 6.81067 10.2679 6.16667ZM4.81836 8.71467L4.70807 8.81267L2.33937 11.1903C1.92652 11.6051 1.88542 12.2595 2.24316 12.7222L2.33937 12.8318L4.70807 15.2095C5.02518 15.5282 5.49786 15.6379 5.9241 15.4919C6.35034 15.3459 6.65475 14.9699 6.70722 14.5247L6.71426 14.3882L6.71544 13.1667L20.8268 13.1667C21.4747 13.1667 22 12.6443 22 12C22 11.3557 21.4747 10.8333 20.8268 10.8333L6.71544 10.8333L6.71543 9.63167C6.71489 9.37349 6.62824 9.12279 6.46906 8.91884L6.36699 8.80217C5.94687 8.38906 5.28338 8.35107 4.81836 8.7135L4.81836 8.71467ZM11.0012 16.6667C10.5964 16.6667 10.2679 17.1893 10.2679 17.8333C10.2679 18.4773 10.5964 19 11.0012 19L21.2667 19C21.6715 19 22 18.4773 22 17.8333C22 17.1893 21.6715 16.6667 21.2667 16.6667L11.0012 16.6667Z"
}, se = {
  key: 1,
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M13.7321 6.16667C13.7321 5.52267 13.4036 5 12.9988 5L2.73326 5C2.3285 5 2 5.52267 2 6.16667C2 6.81067 2.3285 7.33333 2.73326 7.33333L12.9988 7.33334C13.4036 7.33334 13.7321 6.81067 13.7321 6.16667ZM19.1816 8.71467L19.2919 8.81267L21.6606 11.1903C22.0735 11.6051 22.1146 12.2595 21.7568 12.7222L21.6606 12.8318L19.2919 15.2095C18.9748 15.5282 18.5021 15.6379 18.0759 15.4919C17.6497 15.3459 17.3453 14.9699 17.2928 14.5247L17.2857 14.3882L17.2846 13.1667L3.17321 13.1667C2.52526 13.1667 2 12.6443 2 12C2 11.3557 2.52526 10.8333 3.17321 10.8333L17.2846 10.8333L17.2846 9.63167C17.2851 9.37349 17.3718 9.12279 17.5309 8.91884L17.633 8.80217C18.0531 8.38906 18.7166 8.35107 19.1816 8.7135L19.1816 8.71467ZM12.9988 16.6667C13.4036 16.6667 13.7321 17.1893 13.7321 17.8333C13.7321 18.4773 13.4036 19 12.9988 19L2.73325 19C2.3285 19 2 18.4773 2 17.8333C2 17.1893 2.3285 16.6667 2.73325 16.6667L12.9988 16.6667Z"
}, P = /* @__PURE__ */ N({
  __name: "ToggleIcon",
  props: {
    value: { type: Boolean }
  },
  setup(r) {
    return (n, i) => (t(), o("svg", ne, [
      n.value ? (t(), o("path", te)) : (t(), o("path", se))
    ]));
  }
}), oe = { class: "master_nav__line-wrap" }, le = { class: "master_nav__label" }, V = /* @__PURE__ */ N({
  __name: "DivLine",
  props: {
    label: {}
  },
  setup(r) {
    return (n, i) => (t(), o("div", oe, [
      f("h6", le, [
        f("span", null, g(n.label), 1)
      ])
    ]));
  }
});
function ae(r) {
  class n {
    constructor(l, u) {
      m(this, "allSubs");
      this.o = l, this.parent = u, this.allSubs = [
        this,
        ...this.children
      ];
    }
    get key() {
      return this.o.key;
    }
    get children() {
      return (this.o.children || []).map((u) => new n(u, this));
    }
  }
  return r.reduce((a, l) => {
    if (typeof l != "string") {
      const u = new n(l);
      return a.concat(u.allSubs);
    }
    return a;
  }, []);
}
class S {
  constructor() {
    m(this, "products");
    m(this, "_isWide", !1);
    m(this, "currentActiveKey");
    // 子被展开的项
    m(this, "lv2ExpandedList", []);
    m(this, "functionLinks");
    m(this, "partitions");
    m(this, "allowMultiExpand", !0);
    m(this, "onlyLv2Link", !0);
    m(this, "tooltipTransition", "el-fade-in-linear");
    // 是否在非wide模式下的图标下方显示label
    m(this, "showLabelUnderIcon", !1);
    this.products = S.getDefProducts(), this.functionLinks = S.getDefFunctionLinks(), this.currentActiveKey = "home", this.partitions = [...this.functionLinks, "Tools", ...this.products];
  }
  static getDefProducts() {
    return [];
  }
  static getDefFunctionLinks() {
    return [
      {
        key: "workspace",
        icon: "SolidWorkspace",
        children: [
          { key: "my_workspace" },
          { key: "shared_workspace" },
          { key: "public_workspace" }
        ]
      },
      { key: "dashboard", icon: "SolidChartDonut2" },
      { key: "alert", icon: "SolidEmailAlerts" }
    ];
  }
  $t(n) {
    return n;
  }
  // @ts-ignore
  toggleWideHook(n) {
  }
  get isWide() {
    return this._isWide;
  }
  set isWide(n) {
    n !== this._isWide && (this.toggleWideHook(n), this._isWide = n);
  }
  onClickedLinkHook(n, i) {
    console.log("Clicked: ", n, i);
  }
  toggleExpandLv2(n, i) {
    var s, _, p, d;
    const a = ae(this.partitions).filter((c) => c.key === n), l = (s = a[0]) != null && s.children && ((_ = a[0]) == null ? void 0 : _.children.length) > 0 ? n : ((d = (p = a[0]) == null ? void 0 : p.parent) == null ? void 0 : d.key) || n;
    (i === void 0 ? !this.isExpanded(l) : i) ? (this.allowMultiExpand || (this.lv2ExpandedList = []), this.lv2ExpandedList.push(l)) : this.lv2ExpandedList = this.lv2ExpandedList.filter((c) => c !== l);
  }
  openTipLv2Hook(n) {
    console.log("Open:  master_nav-item__2nd_lv_wrap__popover", n);
  }
  onClickedMoreHook(n, i) {
    console.log("Clicked More: ", n, i);
  }
  changeWide() {
    this.isWide = !this.isWide;
  }
  getIsChildActive(n, i = this.partitions) {
    const a = i.filter((l) => typeof l != "string").filter((l) => l.key === n)[0];
    return !a || !a.children ? !1 : a.children.some((l) => l.key === this.currentActiveKey);
  }
  isExpanded(n) {
    return this.lv2ExpandedList.includes(n);
  }
  setExpandedKey(n) {
    this.lv2ExpandedList.includes(n) || this.lv2ExpandedList.push(n);
  }
}
const re = (r, n) => {
  const i = r.__vccOpts || r;
  for (const [a, l] of n)
    i[a] = l;
  return i;
}, de = {}, ce = {
  viewBox: "0 0 7 7",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ve = /* @__PURE__ */ f("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.99998 1.93135V5.99998C6.99998 6.55226 6.55226 6.99998 5.99998 6.99998H1.93135C1.48952 6.99998 1.13135 6.64181 1.13135 6.19998C1.13135 5.98781 1.21563 5.78432 1.36566 5.63429L5.63429 1.36566C5.94671 1.05324 6.45324 1.05324 6.76566 1.36566C6.91569 1.51569 6.99998 1.71918 6.99998 1.93135Z"
}, null, -1), ue = [
  ve
];
function pe(r, n) {
  return t(), o("svg", ce, ue);
}
const _e = /* @__PURE__ */ re(de, [["render", pe]]), me = ["data-item-key", "data-level"], fe = ["aria-expanded", "aria-current"], he = {
  key: 2,
  class: "master_nav-item__label"
}, ke = {
  key: 0,
  style: { "min-width": "200px" },
  class: "master_nav-item__2nd_lv_wrap master_nav-item__2nd_lv_wrap__popover"
}, ye = ["aria-current", "data-level", "data-item-key", "onClick"], Ce = ["data-item-key"], Le = { key: 0 }, ge = { key: 1 }, we = ["innerHTML"], $e = {
  class: "master_nav-item__text",
  "flex-item": "()"
}, be = { class: "master_nav-item__2nd_lv_wrap master_nav-item__2nd_lv_wrap__default" }, Se = ["data-level", "data-item-key"], Ee = { key: 0 }, We = { key: 1 }, Me = /* @__PURE__ */ N({
  __name: "NavItem",
  props: {
    service: { default: () => new S() },
    info: {},
    level: { default: 1 }
  },
  emits: ["on-slot-change", "on-child-active", "on-click-expand", "on-click"],
  setup(r, { emit: n }) {
    const i = r, a = M(!1), l = M([]), u = M(!1), s = k(() => i.service.getIsChildActive(i.info.key, [i.info])), _ = k(() => !!(i.service.currentActiveKey === i.info.key || !i.service.isWide && s.value && i.level === 1)), p = k(() => i.service.isExpanded(i.info.key)), d = k(() => i.info.children && i.info.children.length), c = k(() => i.service.showLabelUnderIcon && !i.service.isWide), y = k(() => d.value && i.info.childLimit !== void 0 && !i.info.showAllChild && !u.value), Z = k(() => {
      const e = i.info.children || [];
      return y.value ? e.slice(0, i.info.childLimit) : e;
    }), j = k(() => (i.info.children || []).slice(i.info.childLimit).map((h) => h.key)), q = (e) => {
      y.value && j.value.includes(e) && (u.value = !0);
    }, B = () => {
      u.value = !0, n("on-child-active");
    }, F = () => {
      d.value && i.service.onlyLv2Link ? n("on-click-expand", i.info.key) : n("on-click", i.info);
    }, G = (e) => {
      l.value.push(...e), n("on-slot-change", l.value);
    }, H = () => {
      u.value = !0, i.service.onClickedMoreHook(i.info.key, i.info);
    }, J = M(null);
    return E(() => a.value, () => {
      i.service.openTipLv2Hook(a.value);
    }), E(() => i.info.slot, (e) => {
      e && n("on-slot-change", [e]);
    }, { immediate: !0 }), E(() => i.service.currentActiveKey, () => {
      q(i.service.currentActiveKey);
    }, { immediate: !0 }), E(() => y.value, (e) => {
      e && n("on-slot-change", [`${i.info.key}LimitSlot`]);
    }, { immediate: !0 }), E(() => s.value, (e) => {
      e && (B(), i.service.setExpandedKey(i.info.key));
    }, { immediate: !0 }), (e, h) => {
      const Q = ee("NavItem", !0);
      return t(), o("div", {
        class: "master_nav-item__wrap",
        "data-item-key": e.info.key,
        "data-level": e.level
      }, [
        e.info.slot ? (t(), o("div", {
          key: 0,
          onClick: F
        }, [
          w(e.$slots, e.info.slot)
        ])) : (t(), o("a", {
          key: 1,
          class: W(["master_nav-item", a.value ? "force-hover-state" : ""]),
          "aria-expanded": e.service.isWide && p.value ? "true" : "false",
          "aria-current": _.value ? "true" : "false",
          flex: "-",
          onClick: F
        }, [
          $(K(R), {
            ref_key: "tooltipRef",
            ref: J,
            modelValue: a.value,
            "onUpdate:modelValue": h[0] || (h[0] = (v) => a.value = v),
            transition: e.service.tooltipTransition,
            "popper-class": `master_nav__tip ${d.value ? "master_nav__tip_lv2" : ""}`,
            offset: 10,
            effect: d.value ? "light" : "dark",
            placement: d.value ? "right-start" : "right",
            "show-arrow": !1,
            disabled: e.service.isWide
          }, {
            content: A(() => [
              d.value ? (t(), o("section", ke, [
                $(V, {
                  label: e.service.$t(e.info.label || e.info.key)
                }, null, 8, ["label"]),
                (t(!0), o(I, null, T(Z.value, (v) => (t(), o("a", {
                  key: v.key,
                  class: "master_nav-item__2nd_lv",
                  "aria-current": e.service.currentActiveKey === v.key ? "true" : "false",
                  "data-level": e.level,
                  "data-item-key": v.key,
                  onClick: (C) => {
                    n("on-click", v), e.service.toggleExpandLv2(v.key, !0);
                  }
                }, g(e.service.$t(v.label || v.key)), 9, ye))), 128)),
                y.value ? w(e.$slots, `${e.info.key}LimitSlot`, {
                  key: 0,
                  handler: H
                }, () => [
                  f("a", {
                    class: W(["master_nav-item__2nd_lv master_nav-item__more", `${e.info.key}-nav__more`]),
                    "data-indent": "2",
                    "data-item-key": `${e.info.key}_key`,
                    onClick: H
                  }, [
                    e.info.limitLabel ? (t(), o("span", Le, g(e.service.$t(e.info.limitLabel)), 1)) : (t(), o("span", ge, "more"))
                  ], 10, Ce)
                ]) : L("", !0)
              ])) : (t(), o("div", {
                key: 1,
                innerHTML: e.service.$t(e.info.label || e.info.key)
              }, null, 8, we))
            ]),
            default: A(() => [
              f("div", {
                class: W([c.value ? "master_nav-item__icon-wrap-under-label-mode" : "master_nav-item__icon-wrap"]),
                "flex-item": ")0(",
                flex: "|center"
              }, [
                e.info.icon ? (t(), b(K(U), {
                  key: 0,
                  "flex-item": "center",
                  "font-size": 24,
                  icon: e.info.icon
                }, null, 8, ["icon"])) : L("", !0),
                d.value && !e.service.isWide ? (t(), b(_e, {
                  key: 1,
                  class: "master_nav-item__triangle"
                })) : L("", !0),
                c.value ? (t(), o("div", he, g(e.service.$t(e.info.label || e.info.key)), 1)) : L("", !0)
              ], 2)
            ]),
            _: 3
          }, 8, ["modelValue", "transition", "popper-class", "effect", "placement", "disabled"]),
          f("div", $e, g(e.service.$t(e.info.label || e.info.key)), 1),
          d.value ? O((t(), o("button", {
            key: 0,
            class: W(["master_nav-item__2nd_lv_btn", { "master_nav-item__2nd_lv_btn_no_hover": e.service.onlyLv2Link }]),
            "flex-item": ")0(start",
            type: "button",
            onClick: h[1] || (h[1] = ie((v) => n("on-click-expand", e.info.key), ["stop"]))
          }, [
            $(K(U), {
              icon: p.value ? "SolidArrowSmallUp" : "SolidArrowsmallDown"
            }, null, 8, ["icon"])
          ], 2)), [
            [D, e.service.isWide]
          ]) : L("", !0)
        ], 10, fe)),
        O(f("section", be, [
          (t(!0), o(I, null, T(e.info.children, (v) => (t(), b(Q, {
            key: v.key,
            info: v,
            service: e.service,
            level: e.level + 1,
            "data-hidden-item": !Z.value.includes(v),
            onOnClickExpand: h[2] || (h[2] = (C) => n("on-click-expand", C)),
            onOnClick: h[3] || (h[3] = (C) => n("on-click", C)),
            onOnSlotChange: G,
            onOnChildActive: B
          }, z({ _: 2 }, [
            T(l.value, (C) => ({
              name: C,
              fn: A(({ handler: X }) => [
                w(e.$slots, C, { handler: X })
              ])
            }))
          ]), 1032, ["info", "service", "level", "data-hidden-item"]))), 128)),
          y.value ? w(e.$slots, `${e.info.key}LimitSlot`, {
            key: 0,
            handler: H
          }, () => [
            f("a", {
              class: W(["master_nav-item__2nd_lv master_nav-item__more", `${e.info.key}-nav__more`]),
              "data-level": e.level + 1,
              "data-item-key": `${e.info.key}_more`,
              onClick: H
            }, [
              e.info.limitLabel ? (t(), o("span", Ee, g(e.service.$t(e.info.limitLabel)), 1)) : (t(), o("span", We, "more"))
            ], 10, Se)
          ]) : L("", !0)
        ], 512), [
          [D, e.service.isWide && d.value && p.value]
        ])
      ], 8, me);
    };
  }
}), Ae = ["aria-expanded"], Ie = {
  key: 0,
  class: "master_nav__trigger__icon-wrap",
  "flex-item": ")0(center"
}, Te = { class: "master_nav__trigger__icon-wrap" }, He = /* @__PURE__ */ N({
  __name: "MasterNav",
  props: {
    service: { default: () => new S() }
  },
  setup(r) {
    const n = r, i = M([]), a = (s) => {
      const _ = "slot:";
      return s.indexOf(_) === 0 ? s.replace(_, "") : "";
    }, l = () => {
      n.service.changeWide();
    }, u = (s) => {
      i.value.push(...s), i.value = Array.from(new Set(i.value));
    };
    return (s, _) => (t(), o("aside", {
      class: "patsnap-biz-master_nav master-nav-render master_nav",
      role: "navigation",
      "aria-expanded": s.service.isWide ? "true" : "false"
    }, [
      f("a", {
        class: "master_nav__trigger",
        flex: "-",
        onClick: l
      }, [
        s.service.isWide ? (t(), o("div", Ie, [
          $(P, {
            value: s.service.isWide
          }, null, 8, ["value"])
        ])) : (t(), b(K(R), {
          key: 1,
          "popper-class": "master_nav__tip",
          effect: "dark",
          placement: "right",
          "show-arrow": !1,
          disabled: s.service.isWide,
          content: s.service.$t("expandSidebar")
        }, {
          default: A(() => [
            f("div", Te, [
              $(P, {
                value: s.service.isWide
              }, null, 8, ["value"])
            ])
          ]),
          _: 1
        }, 8, ["disabled", "content"])),
        O(f("div", {
          class: "master_nav__trigger__text",
          "flex-item": "()center"
        }, g(s.service.$t("hideSidebar")), 513), [
          [D, s.service.isWide]
        ])
      ]),
      $(V, {
        class: "master_nav__top-divline",
        label: ""
      }),
      f("nav", null, [
        (t(!0), o(I, null, T(s.service.partitions, (p, d) => (t(), o(I, null, [
          typeof p == "string" ? (t(), o(I, { key: 0 }, [
            a(p) ? w(s.$slots, a(p), {
              key: 0,
              service: s.service
            }) : a(p) ? L("", !0) : (t(), b(V, {
              key: `divLine_${d}`,
              label: s.service.$t(p)
            }, null, 8, ["label"]))
          ], 64)) : (t(), b(Me, {
            key: d,
            class: "master_nav__item__node",
            info: p,
            service: s.service,
            onOnClick: _[0] || (_[0] = (c) => s.service.onClickedLinkHook(c.key, c)),
            onOnClickExpand: _[1] || (_[1] = (c) => s.service.toggleExpandLv2(c)),
            onOnSlotChange: u
          }, z({ _: 2 }, [
            T(i.value, (c) => ({
              name: c,
              fn: A(({ handler: y }) => [
                w(s.$slots, c, { handler: y })
              ])
            }))
          ]), 1032, ["info", "service"]))
        ], 64))), 256))
      ])
    ], 8, Ae));
  }
}), Ke = He;
Ke.NavService = S;
export {
  Ke as PtMasterNav,
  Ke as default
};
